<template>
  <div class="some-container-for-zoom" ref="container">
    <div class="wrapper" ref="wrapper"></div>
  </div>
  <!--  <gallery-popup ref="gallery" :active-index-prop="activeIndex" :files-prop="filesProp"></gallery-popup>-->
</template>

<script lang="ts" setup>
  import { ref, onMounted } from "vue";
  import { isScreenT } from "@/utils/media-size";
  import { Swiper as SwiperType } from "swiper";

  const props = defineProps({
    swiperMainClass: String,
    zoomElementsClass: String,
    filesProp: Object,
    type: String
  });

  const container = ref<HTMLElement | null>(null);
  const wrapper = ref<HTMLElement | null>(null);
  const cursorMagnifier = ref<HTMLElement | null>(null);
  const zoomElements = ref<NodeList | null>(null);
  const activeIndex = ref(0);
  const swiperMain = ref<SwiperType | null>(null);
  const isScreenTSize = ref(isScreenT);

  const mouseOver = (e: Event) => {
    const zoomer = e.currentTarget as HTMLElement | null;
    if (!zoomer || !zoomer.parentElement) {
      return;
    }

    const image = zoomer.parentElement.querySelector("img.magnifier-image");
    if (!image) {
      return;
    }

    zoomer.style.width = image.clientWidth + "px";
    zoomer.style.height = image.clientHeight + "px";

    if (cursorMagnifier.value) {
      cursorMagnifier.value.remove();
    }

    cursorMagnifier.value = document.createElement("div");
    cursorMagnifier.value.classList.add("magnifier-cursor-figure");
    zoomer.after(cursorMagnifier.value);

    const imgSrc = zoomer.dataset.magnifierSrc;
    wrapper.value?.setAttribute("style", "background-image:url(" + imgSrc + ");");
    container.value?.classList.add("show");
  };

  const mouseOut = () => {
    cursorMagnifier.value?.remove();
    wrapper.value?.setAttribute("style", "background:unset;display:none;");
    container.value?.classList.remove("show");
  };

  const zoom = (e: Event) => {
    const zoomer = e.currentTarget as HTMLElement | null;
    if (!zoomer) {
      return;
    }

    let offsetX, offsetY;
    if (e instanceof MouseEvent) {
      offsetX = e.offsetX;
      offsetY = e.offsetY;
    } else if (e instanceof TouchEvent) {
      offsetX = e.touches[0].pageX;
      offsetY = e.touches[0].pageY;
    } else {
      return;
    }

    const x = (offsetX / zoomer.offsetWidth) * 100;
    const y = (offsetY / zoomer.offsetHeight) * 100;

    if (cursorMagnifier.value) {
      cursorMagnifier.value.style.left = `calc(${x}% - 100px)`;
      cursorMagnifier.value.style.top = `calc(${y}% - 80px)`;
    }

    if (wrapper.value) {
      wrapper.value.style.backgroundPosition = `${x}% ${y}%`;
    }
  };

  const init = () => {
    zoomElements.value = document.querySelectorAll(props.zoomElementsClass as string);

    zoomElements.value?.forEach((tag, index) => {
      if (!isScreenTSize.value) {
        tag.addEventListener("mouseenter", mouseOver);
        tag.addEventListener("mouseleave", mouseOut);
        tag.addEventListener("mousemove", zoom);
      }

      if (props.type === "gallery") {
        tag.addEventListener("click", () => {
          activeIndex.value = swiperMain.value?.swiper?.activeIndex;
          // gallery.value.open(activeIndex.value);
        });
      }
    });
  };

  onMounted(() => {
    swiperMain.value = props.swiperMainClass ? document.querySelector(props.swiperMainClass) : null;
    init();
  });
</script>
